/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
import { ferryFetch } from "@ecom-alliance/libs";
import * as api from "../../api";
import * as image from "../../common/image";
import * as oec_affiliate_creator_marketplace_api from "./oec_affiliate_creator_marketplace_api";
import * as oec_affiliate_invitation_api from "./oec_affiliate_invitation_api";
import * as notification from "../data/notification";
import * as selection from "../data/selection";
import * as brand_deal from "../data/brand_deal";
export { api, image, oec_affiliate_creator_marketplace_api, oec_affiliate_invitation_api, notification, selection, brand_deal };
import { method, headers, queryStringify } from "../../_util";
export var CollectionUpdateType = {
  CU_TYPE_UN_KNOW: 0,
  CU_TYPE_ADD: 1,
  CU_TYPE_REMOVE: 2,
  CU_TYPE_INTEREST: 3
};
export var InvitationType = {
  TARGET_PLAN: 1,
  INVITATION: 2
};
export var OrderField = {
  UN_SPECIFIED: 0,
  LATEST: 1,
  SALES: 2,
  END_TIME_LATEST: 3,
  RECOMMEND: 4
};
export var CreatorInvitationLabel = {
  NEW: 1,
  UPDATE: 2,
  NEED_CONTENT: 3,
  NOT_INTERESTED: 4
};
export var InvitationState = {
  INVITATION_UN_SPECIFIED: 0,
  INVITATION_AVAILABLE: 1,
  INVITATION_EXPIRED: 2,
  INVITATION_TERMINATED: 3,
  INVITATION_DELETED: 4
};
export var InvitationProductState = {
  INVITATION_PRODUCT_UN_SPECIFIED: 0,
  INVITATION_PRODUCT_AVAILABLE: 1,
  INVITATION_PRODUCT_EXPIRED: 2,
  INVITATION_PRODUCT_TERMINATED: 3,
  INVITATION_PRODUCT_DELETED: 4
};
export var LabelType = {
  FREE_SAMPLE: 1,
  HIGHER_COMMISSION: 2,
  COMMISSION_BOOST: 3,
  SALE_PERFORMANCE: 4
};
export var ProductAbnormalPopStatus = {
  UNAVAILABLE_SELLER_DELETE: 11,
  UNAVAILABLE_PLATFORM_DOWN_OR_FORBID: 12
};
export var IMEntranceStatus = {
  IM_ENTRANCE_STATUS_UNKOWN: 0,
  IM_ENTRANCE_STATUS_NORMAL: 1,
  IM_ENTRANCE_STATUS_NOT_AUTHORIZED_2_NONEU_SELLER: 2
};
export var InvitationProductsAddStatus = {
  InvitationProductsAddStatus_NotAdded: 1,
  InvitationProductsAddStatus_PartAdded: 2,
  InvitationProductsAddStatus_AllAdded: 3
};
export var InvitationProductsPostStatus = {
  InvitationProductsPostStatus_NotPost: 1,
  InvitationProductsPostStatus_PartPost: 2,
  InvitationProductsPostStatus_AllPost: 3
};
export var SampleOrderSourceType = {
  SampleOrderSourceTypeDefault: 0,
  SampleOrderSourceTypeBrandDeal: 20
};
export var SampleSupplyChannelType = {
  SampleSupplyChannelOpenCollaboration: 0,
  SampleSupplyChannelTargetInvitation: 1
};
export var DeliveryStatusTagType = {
  IsPosted: 1,
  IsReceivedSample: 2,
  IsAppliedSample: 3,
  IsAddedShowcase: 4
};
export var LabelStyle = {
  FIRE: 100,
  FIRE_HOLLOW: 101,
  THUMB: 200,
  TROPHY: 300
};
export var LabelColor = {
  RED: 1,
  BROWN: 2,
  BLUE: 3
};
export var InvitationChangeConfirmStatus = {
  ConfirmStatus_Unknown: 0,
  ConfirmStatus_Unapproved: 1,
  ConfirmStatus_Approved: 2
};
export var InvitationChangeConfirmType = {
  Confirm_Unknown: 0,
  Confirm_Invitation_Delete: 1,
  Confirm_Product_Remove: 2
};
export var InvitationViewStatus = {
  ViewStatus_New: 1,
  ViewStatus_Normal: 2,
  ViewStatus_Expiring: 3,
  ViewStatus_Expired: 4,
  ViewStatus_Canceling: 5,
  ViewStatus_Canceled: 6
};
export var InviteFilterType = {
  InviteFilterType_Commission: 1,
  InviteFilterType_FlatFee: 2
};
export var UnreadType = {
  New: 1,
  InProgress: 2
};
export var InvitationFilterConfigType = {
  InvitationFilterConfigType_Sort: 1,
  InvitationFilterConfigType_Filter: 2,
  InvitationFilterConfigType_Featured: 3
};
export var InvitationFilterTabType = {
  InvitationFilterTabType_Pending: 10,
  InvitationFilterTabType_Interest: 20,
  InvitationFilterTabType_Interest_All: 21,
  InvitationFilterTabType_Interest_Awaiting_Content: 22,
  InvitationFilterTabType_Interest_Awaiting_Seller_Pay: 23,
  InvitationFilterTabType_Interest_Awaiting_Platform_Review: 24,
  InvitationFilterTabType_Interest_Awaiting_Seller_Review: 25,
  InvitationFilterTabType_Interest_Awaiting_Seller_Post: 26,
  InvitationFilterTabType_Archive: 30,
  InvitationFilterTabType_Archive_All: 31,
  InvitationFilterTabType_Archive_Declined_By_Creator: 32,
  InvitationFilterTabType_Archive_Canceled_By_Seller: 33,
  InvitationFilterTabType_Archive_Expired: 34,
  InvitationFilterTabType_Product_All: 110,
  InvitationFilterTabType_Product_NeedContent: 120,
  InvitationFilterTabType_Product_Inprogress: 121
};
export var FilterItemType = {
  FilterItemTypeSingle: 1,
  FilterItemTypeRange: 2
};
export var InvitationFilterType = {
  FilterType_Category: 1,
  FilterType_FreeSample: 2,
  FilterType_OfficialSeller: 3,
  FilterType_ShopRating: 4,
  FilterType_Featured: 5,
  FilterType_Saved: 6,
  FilterType_HasFlashSale: 7,
  FilterType_ProductCommissionRange: 8,
  FilterType_ProductPriceRange: 9,
  FilterType_ProductRating: 10,
  FilterType_ProductDeliveryStatus: 11,
  FilterType_SubTabInvitationStatus: 12,
  FilterType_FlatFeeRange: 13,
  FilterType_InviteType: 14
};
export var ProductSortField2C = {
  CreatorDeliveryStatusOrder: 1,
  SellerSetOrder: 2
};
export var CreatorIMOptionType = {
  OptionIsOfficial: 1,
  OptionShopRating: 2,
  OptionMessageType: 3,
  OptionProductCategory: 4
};
export var ShopScoreLevel = {
  ShopScoreLow: 0,
  ShopScoreGood: 1,
  ShopScoreGreat: 2,
  ShopScoreExcellent: 3
};
export var MessageType = {
  Text: 1,
  ProductCard: 2,
  SampleCard: 3,
  CRMWithProducts: 4,
  InvitationCard: 5
};
export var InvitationDeclineType = {
  ProductIrrelevant: 1,
  BrandNotTrustWorthy: 2,
  CommissionTooLow: 3,
  SellerNotResponse: 4
};
export var CreatorPreferenceCommissionEnum = {
  Commission_NO_PREFERENCE: 1,
  Commission_GT_0: 2,
  Commission_GT_10: 3,
  Commission_GT_20: 4,
  Commission_GT_30: 5
};
export var CreatorPreferenceSampleEnum = {
  CP_Sample_NO_PREFERENCE: 1,
  CP_Sample_Is_Provide: 2
};
export var CreatorPreferenceShopSoldEnum = {
  ShopSold_GT_0K: 2,
  ShopSold_GT_1K: 3,
  ShopSold_GT_10K: 4,
  ShopSold_GT_50K: 5
};
export var CreatorPreferenceShopRatingEnum = {
  Shop_Rating_NO_PREFERENCE: 1,
  Shop_Rating_GT_3P9: 2,
  Shop_Rating_GT_4P3: 3,
  Shop_Rating_GT_4P5: 4
};
export var IMProductStatus = {
  IM_PRODUCT_UNSPECIFIED: 0,
  IM_PRODUCT_LIVE: 1,
  IM_PRODUCT_QC_FAILED: 2,
  IM_PRODUCT_OUT_OF_STOCK: 3,
  IM_PRODUCT_FREEZE: 4,
  IM_PRODUCT_SELLER_DE_ACTIVE: 5,
  IM_PRODUCT_PLATFORM_DE_ACTIVE: 6,
  IM_PRODUCT_QC_PENDING: 7,
  IM_PRODUCT_DRAFT: 8,
  IM_PRODUCT_DELETE: 9,
  IM_PRODUCT_IN_PLAN: 10,
  IM_PRODUCT_WITHDRAW_BY_PLATFORM: 11,
  IM_PRODUCT_LIMIT_BY_PLATFORM: 12
};
export var PlanType = {
  PLAN_TYPE_UNSPECIFIED: 0,
  PUBLIC: 1,
  TARGET: 2,
  SHOP_PLAN: 3
};
export var PlanStatus = {
  PLAN_STATUS_UNSPECIFIED: 0,
  RUNNING: 1,
  END: 2,
  ENDING: 3,
  UNAVAILABLE: 4,
  INVALID: 5,
  EXPIRED: 6,
  DELETED: 7,
  CREATED: 8,
  PROHIBITED: 9,
  WITHDRAW: 10,
  DELETING: 11,
  EXPIRING: 12
};
export var ProductSourceFrom = {
  SOURCE_THIRD_PARTY: 1,
  SOURCE_AFFILIATE: 2,
  SOURCE_SELF_SALE: 3
};
export var AddShowCaseStatus = {
  IN_SHOW_CASE: 1,
  NOT_IN_SHOW_CASE: 2
};
export var AffiliateCreatorApi = /*#__PURE__*/function () {
  function AffiliateCreatorApi(uriPrefix) {
    this.uriPrefix = typeof uriPrefix !== "undefined" ? uriPrefix : "";
  }
  var _proto = AffiliateCreatorApi.prototype;
  _proto.GetCreatorContactSettings = function GetCreatorContactSettings(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/settings/contact";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.UpdateCreatorContactSettings = function UpdateCreatorContactSettings(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/settings/contact/update";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetScopeMetas = function GetScopeMetas(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/scopemetas" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetCreatorPreference = function GetCreatorPreference(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/settings/preference";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.UpdateCreatorPreference = function UpdateCreatorPreference(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/settings/preference/update";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.ListCreatorInvitation = function ListCreatorInvitation(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/cmp/creator/invite/list/get" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.AffiliateCreatorCollectionUpdateState = function AffiliateCreatorCollectionUpdateState(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/collection/update";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateCreatorInvitationNewFeatureRemind = function AffiliateCreatorInvitationNewFeatureRemind(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/new_feature_remind";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateCreatorInvitationSearch = function AffiliateCreatorInvitationSearch(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/search";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateCreatorInvitationDetail = function AffiliateCreatorInvitationDetail(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/detail";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateCreatorInvitationUnreadCount = function AffiliateCreatorInvitationUnreadCount(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/unread/count";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateCreatorInvitationUnreadClear = function AffiliateCreatorInvitationUnreadClear(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/unread/clear";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetConfirmPageInfo = function GetConfirmPageInfo(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/confirm_page/get";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.ConfirmInvitationChange = function ConfirmInvitationChange(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/confirm_page/confirm";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.InvitationFilterConfig = function InvitationFilterConfig(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/filter/config";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateCreatorInvitationNewClear = function AffiliateCreatorInvitationNewClear(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/new/clear";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateCreatorInvitationAuthBanner = function AffiliateCreatorInvitationAuthBanner(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/auth/banner";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.AffiliateCreatorInvitationAuthBannerCancel = function AffiliateCreatorInvitationAuthBannerCancel(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/auth/banner/cancel";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateCreatorInvitationRecommend = function AffiliateCreatorInvitationRecommend(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/recommend";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateCreatorInvitationEntrance = function AffiliateCreatorInvitationEntrance(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/entrance";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.CheckCreatorIMEntrance = function CheckCreatorIMEntrance(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/im/entrance/check";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.CreatorInvitationProducts = function CreatorInvitationProducts(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/products" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.CreatorUpdateIMRelation = function CreatorUpdateIMRelation(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/im/relation/update";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.CreatorUpdateIMConversation = function CreatorUpdateIMConversation(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/im/conversation/update";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetCreatorIMPermission = function GetCreatorIMPermission(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/im/permission";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.CreatorInvitationDeclineFeedback = function CreatorInvitationDeclineFeedback(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/decline/feedback";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.CreatorInvitationDecline = function CreatorInvitationDecline(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/decline";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.CreatorInvitationReactive = function CreatorInvitationReactive(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/reactive";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.CreatorInvitationAccept = function CreatorInvitationAccept(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/accept";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateCreatorIMOptions = function AffiliateCreatorIMOptions(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/im/options";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateCreatorLastNewMessage = function AffiliateCreatorLastNewMessage(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/im/last_new_message";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.CreatorUpdateIMConversationTag = function CreatorUpdateIMConversationTag(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/im/conversation/update_tag";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.PackIMProductInfo = function PackIMProductInfo(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/im/product/pack";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.CreatorGetIMProductInfo = function CreatorGetIMProductInfo(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/im/product/info" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.CreatorListIMConversation = function CreatorListIMConversation(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/notification/im/list" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.InvitationProductSearch = function InvitationProductSearch(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/product/search";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.CreatorInvitationAuditResult = function CreatorInvitationAuditResult(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/audit/result";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.CreatorBrandInvitationVideoList = function CreatorBrandInvitationVideoList(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/invitation/brand/video/list" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  return AffiliateCreatorApi;
}();
export var affiliateCreatorApiClient = new AffiliateCreatorApi();